// Components
const Tracking = () => import(/* webpackPrefetch: true, webpackChunkName: "treatment-component" */ '@/app/views/main-view/_shared/_components/tracking-component/tracking-component.vue');

// Mixins
import { stickyMenuMixins } from '@/app/mixins/components/sticky-menu-mixins.js';

// Vue modules
import EventBus from '@/app/bus/event-bus.js';

export default {
	name: 'TrackingContainer',
	mixins: [stickyMenuMixins],
	components: {
		Tracking
	},
	computed: {
		isSubscribed() {
			const subscriptions = this.$store.getters.getSubscriptions;
			const tracking = subscriptions.tracking;
			let isSubs = true;
			if (!tracking || tracking.expiredSubscription || !tracking.subscriptionStatus || tracking.subscriptionStatus === 'I' || tracking.subscriptionStatus === 'C') {
				isSubs = false;
			}
			return isSubs;
		}
	},
	mounted() {
		this.bindWindowResize();
		EventBus.$on('setMapHeight', () => {
			this.setMapHeight();
		});
	},
	beforeDestroy() {
		EventBus.$off('setMapHeight', () => {
			this.setMapHeight();
		});
	},
	methods: {
		setMapHeight() {
			const mapOffset = 175; // header and sticky menu sum height
			$('.vue-map-container').css({'height': `${window.innerHeight - mapOffset}px`})
		},
		bindWindowResize() {
			$(window).on('resize', e => {
				this.setMapHeight();
			});
		},
		unbindWindowResize() {
			$(window).off('resize', e => {
				this.setMapHeight();
			});
			$(window).unbind('scroll');
		}
	},
	beforeRouteEnter(to, from, next) {
		EventBus.$emit('showStickyMenu', true);
		next();
	},
	beforeRouteLeave(to, from, next) {
		this.unbindWindowResize();
		this.bindScrollStickyMenu();
		next();
	}
}